import axios from 'axios'
import localforage from 'localforage'
import { writeTrackLog } from "../utils/tracking";
import * as urls from '../config/config'

export const updateActivity = (activity, store) => {
    if (process.env.NODE_ENV === 'development') console.log('Activities.js: updateActivity', activity);
    if (Object.prototype.hasOwnProperty.call(activity, 'synced') && activity.synced) return activity;

    if (store.state.enableTracking) writeTrackLog('Update activity remote' + JSON.stringify(activity));

    return localforage.getItem('token').then(value => {
        return axios.post(
            urls.api.current + '/import/batch',
            { activities: [activity], debug: store.getters.debug },
            { headers: { 'Authorization': 'Bearer ' + value } }
        );
    }).then(({data}) => {
        if (process.env.NODE_ENV === 'development') console.log('Activities.js: updateActivity response', data);

        let updatedEntry = data.data.activities[0];
        updatedEntry.packaging = updatedEntry.packaging_id;
        delete updatedEntry.packaging_id;
        updatedEntry.synced = true;

        if (store.state.enableTracking) writeTrackLog('Updated activity - Server response: ' + JSON.stringify(updatedEntry));

        window.timesheetStore.removeItem(updatedEntry.old_id.toString());

        if (data.data.device) {
            store.dispatch('setCurrentDevice', data.data.device);

            if (store.state.overrideLocal) {
              if (process.env.NODE_ENV === 'development') {
                console.log('ACTIVITIES.JS: UPDATEACTIVITY override local settings', data.data.device)
              }
                store.commit('setActivityOrder', data.data.device.activity_order)
                store.commit('setRowsOrder', data.data.device.rows_order);
                // store.commit('setRowsAsButtons', data.data.device.rows_as_buttons);
                store.commit('setTeamsOrder', data.data.device.teams_order);
                store.commit('setTeamsAsButtons', data.data.device.teams_as_buttons);
            }
        }

        return window.timesheetStore.setItem(updatedEntry.id.toString(), updatedEntry);
    }).then(entry => {
            // if (process.env.NODE_ENV === 'development') console.log('Activities.js: updateActivity local', entry);

            let oldEntry = store.getters.timesheetEntryById(entry.old_id);

            if (oldEntry === undefined || !oldEntry) {
                oldEntry = entry;
            } else {
                oldEntry.id = entry.id;
                oldEntry.location_id = entry.location_id;
                oldEntry.employee_id = entry.employee_id;
                oldEntry.workday_id = entry.workday_id;
                oldEntry.type = entry.type;
                oldEntry.start = entry.start;
                oldEntry.end = entry.end;
                oldEntry.activity_id = entry.activity_id;
                oldEntry.team_name = entry.team_name;
                oldEntry.packaging = entry.packaging;
                oldEntry.row_id = entry.row_id;
                oldEntry.row = entry.row;
                oldEntry.row_status = entry.row_status;
                oldEntry.row_percentage = entry.row_percentage;
                oldEntry.amount = entry.amount;
                oldEntry.on_hold = entry.on_hold;
            }

            oldEntry.synced = true;
            delete oldEntry.old_id;

            if (store.state.enableTracking) writeTrackLog('Synced entry:' + JSON.stringify(oldEntry));
            if (process.env.NODE_ENV === 'development') console.log('Activities.js: updateActivity final', oldEntry);

            return oldEntry;
        })
};
